module.exports = __webpack_public_path__ + "3c441c26f0a0681250ef77dfb3db4750.pdf";